import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import {loader, toastr} from '../CommonActions';
import { auth, userService} from '../../../services';
import { getLoggedinUser } from '../../Actions/EndUser/AuthActions';


export const INVITE_MEMBER = 'INVITE_MEMBER';
export const UPDATE_MEMBERINVITATION = 'UPDATE_MEMBERINVITATION';
export const GET_MEMBERSHIPS_USERS_SUCCESS = 'GET_MEMBERSHIPS_USERS_SUCCESS';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';

const warningColor = 'warning';
const successColor =  "success";
const errorColor = "danger";

export const getMembershipUsers = (id) => {
	return (dispatch) => {
		var url = `${ROOT_API_URL}/MemberInvitation/GetMembershipUsers?membershipId=${id}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((response) => {
			dispatch({
					type: GET_MEMBERSHIPS_USERS_SUCCESS,
					payload: response.data
				});
			})
			.catch((err) => console.log(err));
	};
};



export const inviteMember = (model) => {
	console.log('inviteMember')
	return (dispatch) => {
		dispatch({
			type: INVITE_MEMBER,
			payload: model
		});
		var url = `${ROOT_API_URL}/MemberInvitation/InviteMember`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, model, options).then(function(response) {
            if (response && response.data && response.data.isSuccess) {
                dispatch({
                    type: INVITE_MEMBER,
                    payload: response.data.userList
				});
				
				userService.getUserProfile(auth.getAuthUserEmail()).then(({ data }) => {
					dispatch({
						type: "GET_ACCOUNT_INFO_SUCCESS",
						payload: data
					});
				});
                var success = response && response.data ? response.data.message : 'User Invitation Sent Successfully';
                dispatch(toastr(true, success, successColor));
            } 
            else{
                var warning = response && response.data ? response.data.message : 'User has already been invited and pending approval';
                dispatch(toastr(true, warning, successColor));
            }
            dispatch(loader(false));
        })
        .catch((response) => {
            var err = response && response.data ? response.data.message : 'Network Connection Error';
            dispatch(loader(false));
            dispatch(toastr(true, err, errorColor));
        });
    };
}

export const inviteMemberOnEdit = (model) => {
	return (dispatch) => {
		dispatch({
			type: INVITE_MEMBER,
			payload: model
		});
		var url = `${ROOT_API_URL}/MemberInvitation/InviteMember`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, model, options).then(function (response) {
			dispatch({
				type: INVITE_MEMBER,
				payload: response.data.userList
			});

			userService.getUserProfile(auth.getAuthUserEmail()).then(({ data }) => {
				dispatch({
					type: "GET_ACCOUNT_INFO_SUCCESS",
					payload: data
				});
			});
			var success = response && response.data ? response.data.message : 'User Invitation Sent Successfully';
			dispatch(toastr(true, success, successColor));

			dispatch(loader(false));
		})
		.catch((response) => {
			var err = response && response.data ? response.data.message : 'Network Connection Error';
			dispatch(loader(false));
			dispatch(toastr(true, err, errorColor));
		});
	};
}

export const updateMemberInvitation = (model) => {
	console.log('updateMembershipInvitation')
	return (dispatch) => {
		dispatch({
			type: UPDATE_MEMBERINVITATION,
			payload: model
		});
		var url = `${ROOT_API_URL}/MemberInvitation/UpdateInvitation`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, model, options).then(function(response) {
            if (response && response.data && response.data.isSuccess) {
                dispatch({
                    type: "GET_MY_MEMBERSHIPS_SUCCESS",
                    payload: response.data.memberships
				});
				dispatch({
                    type: "GET_USERS_INVITATIONS",
                    payload: response.data.userInvitations
                });
                var success = response && response.data ? response.data.message : 'User Invitation Sent Successfully';
                dispatch(toastr(true, success, successColor));
            } 
            dispatch(loader(false));
        })
        .catch((response) => {
            var err = response && response.data ? response.data.message : 'Network Connection Error';
            dispatch(loader(false));
            dispatch(toastr(true, err, errorColor));
        });
    };
}
export const DeleteMembershipUser = (details) => {
	return (dispatch) => {
	
		var url = `${ROOT_API_URL}/MemberInvitation/DeleteMembershipUser`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, details, options).then((res) => {
			if (res && res.data && res.data.isSuccess) {
				dispatch({
					type: DELETE_USER_SUCCESS,
					payload: res.data.userList,

				});
				userService.getUserProfile(auth.getAuthUserEmail()).then(({ data }) => {
					dispatch({
						type: "GET_ACCOUNT_INFO_SUCCESS",
						payload: data
					});
				});
			} else {
				dispatch({
					type: DELETE_USER_ERROR,
					payload: res.data.message
				});
			}
		});
	};
};

export const InviteManualUser = (model) => {
	return (dispatch) => {
		dispatch({
			type: INVITE_MEMBER,
			payload: model
		});
		var url = `${ROOT_API_URL}/MemberInvitation/InviteManualUser`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, model, options).then(function(response) {
            if (response && response.data && response.data.isSuccess) {
                dispatch({
                    type: INVITE_MEMBER,
                    payload: response.data.userList
                });
				userService.getUserProfile(auth.getAuthUserEmail()).then(({ data }) => {
					dispatch({
						type: "GET_ACCOUNT_INFO_SUCCESS",
						payload: data
					});
				});
                var success = response && response.data ? response.data.message : 'User Invitation Sent Successfully';
                dispatch(toastr(true, success, successColor));
            } 
            else{
                var warning = response && response.data ? response.data.message : 'User has already been invited and pending approval';
                dispatch(toastr(true, warning, successColor));
            }
            dispatch(loader(false));
        })
        .catch((response) => {
            var err = response && response.data ? response.data.message : 'Network Connection Error';
            dispatch(loader(false));
            dispatch(toastr(true, err, errorColor));
        });
    };
}
